enum ECandidatePageMenuAction {
  Favorite,
  Hide,
  Notes,
  Exclude,
  Report,
}

export default ECandidatePageMenuAction;
